import { render, staticRenderFns } from "./box.vue?vue&type=template&id=09a7416e&scoped=true&"
import script from "./box.vue?vue&type=script&lang=ts&"
export * from "./box.vue?vue&type=script&lang=ts&"
import style0 from "./box.vue?vue&type=style&index=0&id=09a7416e&lang=scss&scoped=true&"
import style1 from "./box.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a7416e",
  null
  
)

export default component.exports